import { useState, useEffect } from 'react';
import { getConditionMonitoringQuestions } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useQuestions = (modelVersionId, roleId, intervalId, showAll = true) => {
  const dispatch = useDispatch();
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const loadQuestions = async () => {
      // Reset questions to empty if modelVersionId is missing
      if (!modelVersionId) {
        setQuestions([]);
        return;
      }
      
      try {
        const response = await getConditionMonitoringQuestions({ 
          modelVersionId,
          roleId: roleId || '',
          intervalId: intervalId || ''
        });
        
        let updatedQuestions = []; // Default to empty
        if (response?.status) {
          const fetchedQuestions = response.data || [];
          
          // Generate unique IDs for each question
          const processedQuestions = fetchedQuestions.map(q => ({
            ...q,
            // Create a unique ID by combining the relevant fields
            id: `${q.modelVersionStageID || ''}-${q.modelVersionTaskQuestionID || ''}-${q.modelVersionZoneID || ''}-${q.modelVersionTaskID || ''}`
          }));
          
          // Only add "Show All" option if explicitly configured to do so
          updatedQuestions = (showAll && processedQuestions.length > 0)
            ? [SHOW_ALL_OPTION, ...processedQuestions]
            : processedQuestions;
        }
        setQuestions(updatedQuestions);
      } catch (error) {
        dispatch(showError('Failed to load questions'));
        setQuestions([]); // Reset on error
      }
    };
    loadQuestions();
  }, [modelVersionId, roleId, intervalId, showAll]);

  return questions;
}; 
